import React from 'react';
import './App.css';
import Header from './components/header/Header';
import Footer from './components/footer/Footer';
import Form from './components/form/Form';

import { initializeIcons } from '@fluentui/font-icons-mdl2';
initializeIcons();

export default class App extends React.Component<{}, {}> {
  public render(): JSX.Element {
    return (
      <div className="App">
        <Header></Header>
        <Form></Form>
        <Footer></Footer>
      </div>
    );
  }
}